import { PartitionLoopIncrementICountState } from "./PartitionLoopIncrementICountState";
import { PartitionLoopIncrementJCountState } from "./PartitionLoopIncrementJCountState";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from '../../enums/QuickSortStep';
import { IQuickSortContext } from '../../IQuickSortContext';

export class PartitionLoopCompareJCountElementPivotState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionLoopCompareJCountPivot;

  Description = "Compare element at j index with pivot";

  private _savedState : { ComparisonResult : boolean | undefined } | undefined;

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void {
    let result : boolean = false;
    
    if (this._context && this._context.JCount !== undefined && 
        this._context.Pivot !== undefined && this._context.Numbers !== undefined) {
      result = this._context.Numbers[this._context.JCount] < this._context.Pivot;
      if (this._savedState === undefined) {
        this._savedState = {
          ComparisonResult: result
        }
      }
      else {
        this._savedState.ComparisonResult = result;
      }
    }
  }

  Undo(): void {
    if (this._savedState) {
      this._savedState.ComparisonResult = undefined;
    }
  }

  Exit(): void {
    if (this._context !== undefined) {
      if (this._savedState?.ComparisonResult) {
        this._context.TransitionTo(new PartitionLoopIncrementICountState());
      }
      else {
        this._context.TransitionTo(new PartitionLoopIncrementJCountState());
      }
    }
  }
}